import CRUDService from './CRUDService';

export interface ChecklistItemStatus {
  _id: string;
  itemId: string;
  status: boolean;
}

export interface ChecklistUserStatus {
  _id: string;
  checklistId: string;
  itemStatuses: ChecklistItemStatus[];
}

export default new CRUDService<ChecklistUserStatus>('/v1/checklists/user-statuses');
